"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var copy = require("copy-to-clipboard");
var styles_1 = require("./styles");
var Toast_1 = require("../../../../components/newUI/Common/Toast");
var banner_1 = require("../../../../pc/utils/banner");
var lang_1 = require("../../../../utils/lang");
var css_1 = require("mobile/utils/css");
var WithPrm_1 = require("components/WithPrm");
var prm_1 = require("utils/prm");
var Coupon = (function (_super) {
    __extends(Coupon, _super);
    function Coupon(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickBtn = function (code, order) {
            var tprm = _this.props.tprm;
            prm_1.sendPrmByParams(__assign(__assign({}, tprm), { position: order + 1 }));
            copy(code);
            _this.setState(function () {
                return {
                    showToast: true
                };
            }, function () {
                setTimeout(function () {
                    _this.setState(function () {
                        return {
                            showToast: false
                        };
                    });
                }, 3000);
            });
        };
        _this.renderCoupon = function (coupons) {
            if (coupons === void 0) { coupons = []; }
            return coupons.map(function (item, index) {
                return (React.createElement(styles_1.CodeBtn, { key: item.img + "_" + index, imgUrl: item.img, onClick: function () {
                        _this.onClickBtn(item.code, index);
                    } }));
            });
        };
        _this.getHeight = function (size) {
            switch (size) {
                case 1:
                    return css_1.px2rem(132);
                case 2:
                    return css_1.px2rem(93);
                case 3:
                    return css_1.px2rem(69);
            }
        };
        _this.getGrid = function (size, rows) {
            if (rows === void 0) { rows = 0; }
            switch (size) {
                case 1:
                    return "\n\t\t\t\tgrid-template-columns:" + css_1.px2rem(351) + ";\n\t\t\t\tgrid-template-rows: " + css_1.px2rem(120) + ";\n\t\t\t\t";
                case 2:
                    return "\n\t\t\t\tgrid-column-gap: " + css_1.px2rem(9) + ";\n\t\t\t\tgrid-row-gap:" + css_1.px2rem(9) + "\n\t\t\t\tgrid-template-columns: repeat(2," + css_1.px2rem(171) + ");\n\t\t\t\tgrid-template-rows:repeat(" + rows + "," + css_1.px2rem(84) + ")};\n\t\t\t\t";
                case 3:
                    return "\n\t\t\t\tgrid-row-gap:" + css_1.px2rem(9) + "\n\t\t\t\tgrid-template-columns: repeat(3, " + css_1.px2rem(140) + ");\n\t\t\t\tgrid-column-gap: " + css_1.px2rem(6) + ";\n\t\t\t\tgrid-template-rows:repeat(" + rows + "," + css_1.px2rem(60) + ")};\n\t\t\t\t\t";
            }
        };
        _this.state = {
            showToast: false,
            columnSize: 1,
            coupons: [],
            id: ""
        };
        return _this;
    }
    Coupon.prototype.componentDidMount = function () {
        var _this = this;
        var _a = banner_1.transformCouponInfo(this.props.moduleDetail), coupons = _a.coupons, columnSize = _a.columnSize;
        this.setState(function () {
            return {
                coupons: coupons,
                columnSize: columnSize,
                id: _this.props.moduleDetail.id
            };
        });
    };
    Coupon.prototype.render = function () {
        var _a = this.state, showToast = _a.showToast, columnSize = _a.columnSize, id = _a.id, coupons = _a.coupons;
        if (!!!coupons || coupons.length === 0) {
            return null;
        }
        return (React.createElement(styles_1.Container, { id: id, columnSize: columnSize, height: this.getHeight(columnSize) },
            React.createElement(styles_1.BtnWrapper, null,
                React.createElement(styles_1.InnerBox, { columnSize: columnSize, grid: this.getGrid(columnSize, Math.ceil(coupons.length / +columnSize)) }, this.renderCoupon(coupons))),
            showToast && React.createElement(Toast_1.default, { message: lang_1.getLitbLangFn()("Coupon successfully copied") + "!" })));
    };
    return Coupon;
}(React.Component));
exports.default = WithPrm_1.default(Coupon);
